/* PCL collection page (26-9-2026 rebuild; single price 27-9-2026): tag + Search & Discovery filters, sort and numbered
   pagination through the Section Rendering API (state in the URL), mobile filter drawer,
   3 view modes, pack-aware quantity, add-to-basket feedback, compare tray/modal, scroll restore. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pcl-collection]');
  if (!root) return;
  var sectionId = root.getAttribute('data-section-id');
  var results = root.querySelector('[data-pcl-results]');
  var filters = root.querySelector('[data-pcl-filters]');
  var toast = root.querySelector('[data-pcl-toast]');
  var toastTimer = null;
  var debounce = null;
  var controller = null;
  var baseUrl = root.getAttribute('data-url');

  function qs(sel, ctx) { return (ctx || root).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }

  /* ---------- URL building: /collections/handle[/tag+tag]?filter...&sort_by=... ---------- */
  function buildUrlFromForm() {
    var form = qs('[data-pcl-form]');
    if (!form) return baseUrl;
    var params = new URLSearchParams();
    var tags = [];
    var fd = new FormData(form);
    fd.forEach(function (value, key) {
      if (value === '' || value === null) return;
      if (key === 'pcl_tag') { tags.push(value); return; }
      params.append(key, value);
    });
    var path = tags.length ? baseUrl + '/' + tags.join('+') : baseUrl;
    var q = params.toString();
    return q ? path + '?' + q : path;
  }

  /* keep sort + filter params when a tag pill link (path-only) is followed */
  function withCurrentQuery(href) {
    var cur = new URLSearchParams(window.location.search);
    cur.delete('page');
    cur.delete('section_id');
    var target = new URL(href, window.location.origin);
    cur.forEach(function (v, k) { if (!target.searchParams.has(k)) target.searchParams.append(k, v); });
    return target.pathname + (target.search || '');
  }

  function render(url, opts) {
    opts = opts || {};
    if (controller) controller.abort();
    controller = new AbortController();
    results.classList.add('is-loading');
    results.setAttribute('aria-busy', 'true');
    var sep = url.indexOf('?') > -1 ? '&' : '?';
    fetch(url + sep + 'section_id=' + encodeURIComponent(sectionId), { signal: controller.signal })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newRoot = doc.querySelector('[data-pcl-collection]');
        var newResults = doc.querySelector('[data-pcl-results]');
        var newFilters = doc.querySelector('[data-pcl-filters]');
        if (newRoot) root.setAttribute('data-tag-path', newRoot.getAttribute('data-tag-path') || '');
        if (newResults) results.innerHTML = newResults.innerHTML;
        if (newFilters && filters) {
          var openState = {};
          qsa('[data-pcl-facet]', filters).forEach(function (d) { openState[d.getAttribute('data-pcl-facet')] = d.open; });
          var wasOpen = filters.classList.contains('is-open');
          filters.innerHTML = newFilters.innerHTML;
          qsa('[data-pcl-facet]', filters).forEach(function (d) {
            var k = d.getAttribute('data-pcl-facet');
            if (k in openState) d.open = openState[k];
          });
          if (wasOpen) filters.classList.add('is-open');
        }
        if (!opts.silent) history.pushState({ pcl: true }, '', url);
        applyDensity();
        syncCompareBoxes();
        results.classList.remove('is-loading');
        results.setAttribute('aria-busy', 'false');
        if (opts.scroll !== false) {
          var top = root.getBoundingClientRect().top + window.scrollY - stickyOffset() - 12;
          if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
        }
      })
      .catch(function (e) {
        if (e && e.name === 'AbortError') return;
        results.classList.remove('is-loading');
        results.setAttribute('aria-busy', 'false');
        window.location.href = url;
      });
  }
  function stickyOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--pcs-sticky-h');
    var n = parseInt(v, 10);
    return isNaN(n) ? 124 : n;
  }

  /* ---------- events (delegated so re-rendered markup keeps working) ---------- */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-pcl-cmp]')) { toggleCompare(t); return; }
    if (t.matches('[data-pcl-qty-input]')) { updateQtySummary(t.closest('[data-pcl-add]')); return; }
    if (t.matches('[data-pcl-auto]')) {
      clearTimeout(debounce);
      debounce = setTimeout(function () { render(buildUrlFromForm()); }, 250);
    } else if (t.matches('[data-pcl-sort]')) {
      var hidden = qs('[data-pcl-sort-hidden]');
      if (hidden) hidden.value = t.value;
      render(buildUrlFromForm());
    }
  });
  root.addEventListener('input', function (e) {
    if (e.target.matches('[data-pcl-qty-input]')) updateQtySummary(e.target.closest('[data-pcl-add]'));
  });

  root.addEventListener('submit', function (e) {
    var form = e.target;
    if (form.matches('[data-pcl-form]')) {
      e.preventDefault();
      render(buildUrlFromForm());
      closeFilters();
    } else if (form.matches('[data-pcl-add]')) {
      e.preventDefault();
      addToCart(form);
    }
  });

  root.addEventListener('click', function (e) {
    var link = e.target.closest('[data-pcl-link]');
    if (link && root.contains(link)) {
      e.preventDefault();
      var href = link.getAttribute('href');
      if (link.hasAttribute('data-pcl-keep-query')) href = withCurrentQuery(href);
      render(href);
      return;
    }
    var plink = e.target.closest('[data-pcl-product-link]');
    if (plink) { savePosition(); return; }
    if (e.target.closest('[data-pcl-open-filters]')) { openFilters(); return; }
    if (e.target.closest('[data-pcl-close-filters]')) { closeFilters(); return; }
    var more = e.target.closest('[data-pcl-facet-more]');
    if (more) {
      var list = more.parentElement.querySelector('.pcl-facet__list');
      var expanded = list.classList.toggle('is-expanded');
      more.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (!more.getAttribute('data-label')) more.setAttribute('data-label', more.textContent);
      more.textContent = expanded ? 'Show fewer' : more.getAttribute('data-label');
      return;
    }
    var dens = e.target.closest('[data-pcl-density]');
    if (dens) {
      try { localStorage.setItem('pcl-density', dens.getAttribute('data-pcl-density')); } catch (err) {}
      applyDensity();
      return;
    }
    if (e.target.closest('[data-pcl-cmp-open]')) { openCompare(); return; }
    if (e.target.closest('[data-pcl-cmp-close]')) { closeCompare(); return; }
    if (e.target.closest('[data-pcl-cmp-clear]')) { clearCompare(); return; }
    var rm = e.target.closest('[data-pcl-cmp-rm]');
    if (rm) { removeCompare(rm.getAttribute('data-pcl-cmp-rm')); return; }
    if (e.target === compareModal) { closeCompare(); return; }
    var qty = e.target.closest('[data-pcl-qty]');
    if (qty) {
      var input = qty.parentElement.querySelector('input');
      var next = (parseInt(input.value, 10) || 1) + parseInt(qty.getAttribute('data-pcl-qty'), 10);
      input.value = Math.max(1, next);
      updateQtySummary(qty.closest('[data-pcl-add]'));
      return;
    }
  });

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.pcl) render(window.location.href, { silent: true, scroll: false });
  });

  /* ---------- filter drawer (mobile) ---------- */
  function openFilters() {
    if (!filters) return;
    filters.classList.add('is-open');
    document.body.classList.add('pcl-filters-open');
    var b = qs('[data-pcl-open-filters]');
    if (b) b.setAttribute('aria-expanded', 'true');
    var first = filters.querySelector('input, button, a');
    if (first) first.focus({ preventScroll: true });
  }
  function closeFilters() {
    if (!filters || !filters.classList.contains('is-open')) return;
    filters.classList.remove('is-open');
    document.body.classList.remove('pcl-filters-open');
    var b = qs('[data-pcl-open-filters]');
    if (b) { b.setAttribute('aria-expanded', 'false'); b.focus({ preventScroll: true }); }
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeFilters(); closeCompare(); } });

  /* ---------- view mode ---------- */
  var allowedDensity = ['3', '4', 'list'];
  function applyDensity() {
    var grid = qs('[data-pcl-grid]');
    var val = '4';
    try { val = localStorage.getItem('pcl-density') || '4'; } catch (err) {}
    if (allowedDensity.indexOf(val) < 0) val = '4';
    if (grid) {
      grid.classList.remove('pcl-grid--3', 'pcl-grid--4', 'pcl-grid--5', 'pcl-grid--list');
      grid.classList.add('pcl-grid--' + val);
    }
    qsa('[data-pcl-density]').forEach(function (b) {
      var on = b.getAttribute('data-pcl-density') === val;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  applyDensity();

  /* ---------- head: description clamp + "More categories" ---------- */
  var desc = document.querySelector('[data-pcl-desc]');
  if (desc) {
    var inner = desc.querySelector('.pcl-head__desc-inner');
    var btn = desc.querySelector('[data-pcl-desc-toggle]');
    if (inner && btn && inner.scrollHeight > 64) {
      desc.classList.add('is-clamped');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var clamped = desc.classList.toggle('is-clamped');
        btn.textContent = clamped ? 'Read more' : 'Read less';
        btn.setAttribute('aria-expanded', clamped ? 'false' : 'true');
      });
    }
  }
  var chipNav = document.querySelector('[data-pcl-chips]');
  if (chipNav) {
    chipNav.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pcl-chips-more]');
      if (!b) return;
      chipNav.classList.add('is-expanded');
      b.setAttribute('aria-expanded', 'true');
      var firstExtra = chipNav.querySelector('.pcl-chip.is-extra');
      if (firstExtra) firstExtra.focus();
    });
  }

  /* ---------- quantity summary ("2 packs · 24 pieces") ---------- */
  function updateQtySummary(form) {
    if (!form) return;
    var sum = form.querySelector('[data-pcl-add-sum]');
    var pack = parseInt(form.getAttribute('data-pack'), 10) || 0;
    var input = form.querySelector('[data-pcl-qty-input]');
    if (!sum || pack < 2 || !input) return;
    var n = Math.max(1, parseInt(input.value, 10) || 1);
    sum.textContent = n + (n === 1 ? ' pack · ' : ' packs · ') + (n * pack).toLocaleString('en-GB') + ' pieces';
  }

  /* ---------- scroll position restore (back from a product) ---------- */
  function savePosition() {
    try { sessionStorage.setItem('pcl-pos', JSON.stringify({ url: window.location.href, y: window.scrollY })); } catch (err) {}
  }
  (function restorePosition() {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('pcl-pos') || 'null'); sessionStorage.removeItem('pcl-pos'); } catch (err) {}
    if (!saved || saved.url !== window.location.href) return;
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (nav && nav.type === 'back_forward') {
      window.setTimeout(function () { window.scrollTo(0, saved.y); }, 50);
    }
  })();

  /* ---------- compare (up to 4, kept for the session) ---------- */
  var compareBar = root.querySelector('[data-pcl-cmpbar]');
  var compareModal = root.querySelector('.pcl-cmp');
  var compareMax = 4;
  var lastFocus = null;
  var ROWS = [
    ['Capacity', ['Capacity']],
    ['Diameter / width', ['Diameter', 'Width', 'Length']],
    ['Material', ['Material']],
    ['Colour', ['Colour']]
  ];
  function readCompare() {
    try { return JSON.parse(sessionStorage.getItem('pcl-compare') || '[]'); } catch (err) { return []; }
  }
  function writeCompare(list) {
    try { sessionStorage.setItem('pcl-compare', JSON.stringify(list)); } catch (err) {}
    renderCompareBar(list);
    syncCompareBoxes(list);
  }
  function itemFromCard(card) {
    return {
      id: card.getAttribute('data-id'), title: card.getAttribute('data-title'), url: card.getAttribute('data-url'),
      img: card.getAttribute('data-img'), price: card.getAttribute('data-price'),
      pack: card.getAttribute('data-pack'), specs: card.getAttribute('data-specs')
    };
  }
  function toggleCompare(box) {
    var card = box.closest('[data-pcl-item]');
    if (!card) return;
    var list = readCompare();
    var id = card.getAttribute('data-id');
    var idx = list.findIndex(function (i) { return i.id === id; });
    if (box.checked) {
      if (idx > -1) return;
      if (list.length >= compareMax) { box.checked = false; showToast('You can compare up to ' + compareMax + ' products'); return; }
      list.push(itemFromCard(card));
    } else if (idx > -1) {
      list.splice(idx, 1);
    }
    writeCompare(list);
  }
  function removeCompare(id) {
    var list = readCompare().filter(function (i) { return i.id !== id; });
    writeCompare(list);
    if (compareModal && !compareModal.hidden) { if (list.length > 1) openCompare(); else closeCompare(); }
  }
  function clearCompare() { writeCompare([]); closeCompare(); }
  function syncCompareBoxes(list) {
    list = list || readCompare();
    var ids = list.map(function (i) { return i.id; });
    qsa('[data-pcl-item]').forEach(function (card) {
      var box = card.querySelector('[data-pcl-cmp]');
      if (box) box.checked = ids.indexOf(card.getAttribute('data-id')) > -1;
    });
  }
  function renderCompareBar(list) {
    if (!compareBar) return;
    if (!list.length) { compareBar.hidden = true; document.body.classList.remove('pcl-has-cmpbar'); return; }
    var wrap = compareBar.querySelector('[data-pcl-cmpbar-items]');
    var html = '';
    list.forEach(function (i) {
      html += '<div class="pcl-cmpbar__item" title="' + esc(i.title) + '">' + (i.img ? '<img src="' + esc(i.img) + '" alt="">' : '') +
        '<button type="button" aria-label="Remove ' + esc(i.title) + ' from compare" data-pcl-cmp-rm="' + esc(i.id) + '">×</button></div>';
    });
    for (var k = list.length; k < compareMax; k++) html += '<div class="pcl-cmpbar__slot" aria-hidden="true"></div>';
    wrap.innerHTML = html;
    var n = compareBar.querySelector('[data-pcl-cmp-n]');
    if (n) n.textContent = list.length + ' of ' + compareMax + ' selected';
    var openBtn = compareBar.querySelector('[data-pcl-cmp-open]');
    openBtn.disabled = list.length < 2;
    openBtn.textContent = list.length < 2 ? 'Pick 2 or more to compare' : 'Compare ' + list.length;
    compareBar.hidden = false;
    document.body.classList.add('pcl-has-cmpbar');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function cell(v) { return v ? '<td>' + esc(v) + '</td>' : '<td class="is-missing">Not listed</td>'; }
  function openCompare() {
    var list = readCompare();
    if (!compareModal || list.length < 2) return;
    var body = compareModal.querySelector('[data-pcl-cmp-body]');
    var specMap = list.map(function (i) {
      var m = {};
      (i.specs || '').split('~~').forEach(function (line) {
        var p = line.indexOf(':');
        if (p < 0) return;
        m[line.slice(0, p).trim()] = line.slice(p + 1).trim();
      });
      return m;
    });
    var h = '<table style="--n:' + list.length + '"><tbody>';
    h += '<tr><th scope="row">Product</th>' + list.map(function (i) {
      return '<td>' + (i.img ? '<img class="pcl-cmp__img" src="' + esc(i.img) + '" alt="">' : '') +
        '<a class="pcl-cmp__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
        '<button type="button" class="pcl-cmp__rm" data-pcl-cmp-rm="' + esc(i.id) + '">Remove</button></td>';
    }).join('') + '</tr>';
    ROWS.forEach(function (row) {
      h += '<tr><th scope="row">' + row[0] + '</th>' + specMap.map(function (m) {
        var v = '';
        row[1].forEach(function (k) { if (!v && m[k]) v = m[k]; });
        return cell(v);
      }).join('') + '</tr>';
    });
    h += '<tr><th scope="row">Pack size</th>' + list.map(function (i) {
      var p = parseInt(i.pack, 10) || 0;
      return p > 1 ? '<td><span class="pcl-cmp__pack">Pack of ' + p + '</span></td>' : '<td>Sold individually</td>';
    }).join('') + '</tr>';
    h += '<tr><th scope="row">Price</th>' + list.map(function (i) { return '<td><span class="pcl-cmp__price">' + esc(i.price) + '</span></td>'; }).join('') + '</tr>';
    h += '</tbody></table>';
    body.innerHTML = h;
    lastFocus = document.activeElement;
    compareModal.hidden = false;
    document.body.classList.add('pcl-cmp-open');
    var closeBtn = compareModal.querySelector('[data-pcl-cmp-close]');
    if (closeBtn) closeBtn.focus();
  }
  function closeCompare() {
    if (!compareModal || compareModal.hidden) return;
    compareModal.hidden = true;
    document.body.classList.remove('pcl-cmp-open');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  if (compareModal) {
    compareModal.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = qsa('a, button', compareModal).filter(function (el) { return !el.disabled && el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  renderCompareBar(readCompare());
  syncCompareBoxes();

  /* ---------- add to basket ---------- */
  function showToast(text, isError) {
    if (!toast) return;
    var t = toast.querySelector('[data-pcl-toast-text]');
    if (t) t.textContent = text;
    toast.classList.toggle('is-error', !!isError);
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.hidden = true; }, 4000);
  }
  function addToCart(form) {
    if (form.classList.contains('is-busy')) return;
    form.classList.add('is-busy');
    form.classList.remove('is-error');
    var fd = new FormData(form);
    var q = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
    fd.set('quantity', String(q));
    var pack = parseInt(form.getAttribute('data-pack'), 10) || 0;
    fetch(form.getAttribute('action') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        form.classList.remove('is-busy');
        if (!res.ok) {
          form.classList.add('is-error');
          setTimeout(function () { form.classList.remove('is-error'); }, 2500);
          showToast(res.body && res.body.description ? res.body.description : 'Could not add to basket', true);
          return;
        }
        form.classList.add('is-done');
        setTimeout(function () { form.classList.remove('is-done'); }, 2000);
        var msg = pack > 1 ? (q + (q === 1 ? ' pack' : ' packs') + ' (' + (q * pack) + ' pieces) added to basket') : (q > 1 ? q + ' added to basket' : 'Added to basket');
        showToast(msg);
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { source: 'pcl' } }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pcl' } }));
      })
      .catch(function () {
        form.classList.remove('is-busy');
        form.classList.add('is-error');
        setTimeout(function () { form.classList.remove('is-error'); }, 2500);
        showToast('Could not add to basket — please try again', true);
      });
  }
})();